/**
 * BYOB - Multi-Step Bundle Selection (Simplified)
 * Buy 2 @ Fixed Price with Step-by-Step Selection
 */

(function() {
  'use strict';

  const wrapper = document.querySelector('.byob-wrapper');
  if (!wrapper) return;

  // Configuration
  const discountType = wrapper.dataset.discountType;
  const ENGRAVING_VARIANT_ID = 48569060327647; // Engraving Charge product variant ID (as number)
  
  // Parse tab configurations
  let tabConfigs = {};
  try {
    tabConfigs = JSON.parse(wrapper.dataset.tabConfigs || '{}');
  } catch (e) {
    console.error('BYOB: Invalid tab configs');
    tabConfigs = {};
  }
  
  let discountRules = [];
  try {
    discountRules = JSON.parse(wrapper.dataset.discountRules || '[]');
  } catch (e) {
    console.error('BYOB: Invalid discount rules');
    discountRules = [];
  }

  // State - Dynamic based on active tab or wrapper settings
  let currentTab = 'buy2'; // Default to buy2
  let currentStep = 1;
  let maxItems = parseInt(wrapper.dataset.maxItems) || 2; // Get from wrapper or default to 2
  let currentBundlePrice = discountRules.length > 0 ? discountRules[0].value : 1299;
  let bundleMode = tabConfigs.buy2?.mode || wrapper.dataset.mode || 'step';
  let ENGRAVING_ENABLED = tabConfigs.buy2?.engraving || (wrapper.dataset.enableEngraving === 'true');
  
  console.log('BYOB Initial Tab:', currentTab);
  console.log('Tab Configs:', tabConfigs);
  
  let selectedProducts = {
    step1: null,
    step2: null,
    step3: null
  };

  // DOM Elements
  const boxContainer = document.querySelector('.byob-box-container');
  const boxMessage = document.querySelector('.byob-box-message');
  const boxTotal = document.querySelector('.byob-total-price');
  const boxOriginalPrice = document.querySelector('.byob-original-price');
  const savingsBadge = document.querySelector('.byob-savings-badge');
  const savingsText = document.querySelector('.byob-savings-text');
  const checkoutBtn = document.querySelector('.byob-checkout-btn');
  const resetBtn = document.querySelector('.byob-box-reset');
  const slots = document.querySelectorAll('.byob-slot');
  const stepNavigations = document.querySelectorAll('.byob-box-step');
  const stepContents = document.querySelectorAll('.byob-step-content');
  const boxCloseBtn = document.querySelector('.byob-box-close');
  const boxReopenBtn = document.querySelector('.byob-box-reopen');
  const boxReopenCount = document.querySelector('.byob-box-reopen-count');

  /**
   * Initialize
   */
  function init() {
    // Attach event listeners
    attachEventListeners();
    
    // Initialize tabs
    initializeTabs();
    
    updateUI();
  }

  /**
   * Initialize tab switching functionality
   */
  function initializeTabs() {
    const tabs = document.querySelectorAll('.byob-tab');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const bundleSize = parseInt(this.dataset.bundleSize);
        const bundlePrice = parseFloat(this.dataset.bundlePrice);
        const tabId = this.dataset.tabId;
        
        // Update active tab
        tabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        
        // Update current tab state
        currentTab = tabId;
        maxItems = bundleSize;
        currentBundlePrice = bundlePrice;
        
        // Update tab-specific settings
        const tabConfig = tabConfigs[tabId] || {};
        bundleMode = tabConfig.mode || 'step';
        ENGRAVING_ENABLED = tabConfig.engraving || false;
        
        // Update wrapper data attributes
        wrapper.dataset.maxItems = bundleSize;
        wrapper.dataset.mode = bundleMode;
        wrapper.dataset.enableEngraving = ENGRAVING_ENABLED ? 'true' : 'false';
        
        // Show/hide tab content
        document.querySelectorAll('.byob-tab-content').forEach(content => {
          if (content.dataset.tabContent === tabId) {
            content.style.display = 'block';
          } else {
            content.style.display = 'none';
          }
        });
        
        // Show/hide third slot based on bundle size
        const slot3 = document.querySelector('.byob-slot[data-slot="3"]');
        if (slot3) {
          slot3.style.display = bundleSize >= 3 ? 'flex' : 'none';
        }
        
        // Update step labels in bottom box
        updateStepLabels(bundleSize);
        
        // Reset all selections when switching tabs
        selectedProducts.step1 = null;
        selectedProducts.step2 = null;
        selectedProducts.step3 = null;
        currentStep = 1;
        
        // Re-attach event listeners for new products
        reattachEventListeners();
        
        // Update UI
        updateUI();
        
        console.log('Tab switched:', { 
          tabId, 
          bundleSize, 
          bundlePrice, 
          maxItems, 
          bundleMode, 
          engravingEnabled: ENGRAVING_ENABLED 
        });
      });
    });
  }

  /**
   * Re-attach event listeners after tab switch
   */
  function reattachEventListeners() {
    // Variant swatch clicks
    document.querySelectorAll('.byob-swatch').forEach(swatch => {
      swatch.removeEventListener('click', handleSwatchClick);
      swatch.addEventListener('click', handleSwatchClick);
    });

    // Select button clicks
    document.querySelectorAll('.byob-add-btn').forEach(btn => {
      btn.removeEventListener('click', handleProductSelection);
      btn.addEventListener('click', handleProductSelection);
    });

    // Product image clicks for quick view
    document.querySelectorAll('.byob-product-image').forEach(img => {
      const newImg = img.cloneNode(true);
      img.parentNode.replaceChild(newImg, img);
      newImg.addEventListener('click', function() {
        const card = this.closest('.byob-product-card');
        openQuickView(card);
      });
    });

    // Learn more clicks
    document.querySelectorAll('.byob-learn-more').forEach(link => {
      const newLink = link.cloneNode(true);
      link.parentNode.replaceChild(newLink, link);
      newLink.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const card = this.closest('.byob-product-card');
        openQuickView(card);
      });
    });
  }

  /**
   * Update step labels based on bundle size
   */
  function updateStepLabels(bundleSize) {
    const boxSteps = document.querySelectorAll('.byob-box-step');
    
    if (bundleSize === 2) {
      // Buy 2: Show only 2 steps
      boxSteps.forEach((step, index) => {
        if (index === 0) {
          step.querySelector('.byob-box-step-text').textContent = 'Choose First Product';
          step.style.display = 'flex';
        } else if (index === 1) {
          step.querySelector('.byob-box-step-text').textContent = 'Choose Second Product';
          step.style.display = 'flex';
        } else if (index === 2) {
          step.querySelector('.byob-box-step-text').textContent = 'Complete';
          step.style.display = 'flex';
        }
      });
      
      // Hide third step line
      const stepLines = document.querySelectorAll('.byob-box-step-line');
      stepLines.forEach((line, index) => {
        line.style.display = index < 2 ? 'block' : 'none';
      });
    } else if (bundleSize === 3) {
      // Buy 3: Show all 3 steps
      boxSteps.forEach((step, index) => {
        if (index === 0) {
          step.querySelector('.byob-box-step-text').textContent = 'First Product';
          step.style.display = 'flex';
        } else if (index === 1) {
          step.querySelector('.byob-box-step-text').textContent = 'Second Product';
          step.style.display = 'flex';
        } else if (index === 2) {
          step.querySelector('.byob-box-step-text').textContent = 'Third Product';
          step.style.display = 'flex';
        }
      });
      
      // Show all step lines
      const stepLines = document.querySelectorAll('.byob-box-step-line');
      stepLines.forEach(line => {
        line.style.display = 'block';
      });
    }
  }

  /**
   * Attach all event listeners
   */
  function attachEventListeners() {
    // Variant swatch clicks
    document.querySelectorAll('.byob-swatch').forEach(swatch => {
      swatch.addEventListener('click', handleSwatchClick);
    });

    // Select button clicks
    document.querySelectorAll('.byob-add-btn').forEach(btn => {
      btn.addEventListener('click', handleProductSelection);
    });

    // Product image clicks for quick view
    document.querySelectorAll('.byob-product-image').forEach(img => {
      img.addEventListener('click', function() {
        const card = this.closest('.byob-product-card');
        openQuickView(card);
      });
    });

    // Learn more clicks
    document.querySelectorAll('.byob-learn-more').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const card = this.closest('.byob-product-card');
        openQuickView(card);
      });
    });

    // Reset button
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        selectedProducts.step1 = null;
        selectedProducts.step2 = null;
        goToStep(1);
      });
    }

    // Checkout button
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', handleCheckout);
    }

    // Close box button
    if (boxCloseBtn) {
      boxCloseBtn.addEventListener('click', closeBox);
    }

    // Reopen box button
    if (boxReopenBtn) {
      boxReopenBtn.addEventListener('click', reopenBox);
    }
  }

  /**
   * Close the bottom box
   */
  function closeBox() {
    if (boxContainer) {
      boxContainer.classList.remove('visible');
      boxContainer.classList.add('hidden');
    }
    if (boxReopenBtn) {
      boxReopenBtn.style.display = 'flex';
      // Update count in reopen button
      const selectedCount = (selectedProducts.step1 ? 1 : 0) + (selectedProducts.step2 ? 1 : 0) + (selectedProducts.step3 ? 1 : 0);
      if (boxReopenCount) {
        boxReopenCount.textContent = selectedCount;
      }
    }
  }

  /**
   * Reopen the bottom box
   */
  function reopenBox() {
    if (boxContainer) {
      boxContainer.classList.remove('hidden');
      boxContainer.classList.add('visible');
    }
    if (boxReopenBtn) {
      boxReopenBtn.style.display = 'none';
    }
  }

  /**
   * Handle variant swatch click
   */
  function handleSwatchClick() {
    if (this.dataset.disabled) return;

    const productId = this.dataset.productId;
    const variantId = this.dataset.variantId;
    const price = this.dataset.price;
    const comparePrice = this.dataset.compare;
    const variantTitle = this.dataset.title;
    const variantImage = this.dataset.image;

    const productCard = this.closest('.byob-product-card');
    
    // Update active swatch
    const allSwatches = productCard.querySelectorAll('.byob-swatch');
    allSwatches.forEach(s => s.classList.remove('active'));
    this.classList.add('active');

    // Update main image
    const mainImage = productCard.querySelector('.byob-main-image');
    if (mainImage) {
      mainImage.src = variantImage;
    }

    // Update variant name
    const variantNameEl = productCard.querySelector('.byob-variant-name');
    if (variantNameEl) {
      variantNameEl.textContent = variantTitle;
    }

    // Update price
    const priceRow = productCard.querySelector('.byob-product-price-row');
    if (priceRow) {
      updatePriceDisplay(priceRow, price, comparePrice);
    }

    // Update select button
    const addBtn = productCard.querySelector('.byob-add-btn');
    if (addBtn) {
      addBtn.dataset.variantId = variantId;
      addBtn.dataset.price = price;
      addBtn.dataset.image = variantImage;
    }
  }

  /**
   * Update price display
   */
  function updatePriceDisplay(priceRow, price, comparePrice) {
    const pricesDiv = priceRow.querySelector('.byob-prices');
    const priceValue = parseFloat(price);
    const compareValue = comparePrice ? parseFloat(comparePrice) : 0;
    
    // Format price without decimals (price is in paise, divide by 100)
    const formattedPrice = Math.round(priceValue / 100);
    let priceHTML = `<span class="byob-price-current"><span class="inr-sign"></span> ₹ ${formattedPrice.toLocaleString('en-IN')}</span>`;
    
    if (compareValue > priceValue) {
      const formattedComparePrice = Math.round(compareValue / 100);
      priceHTML += `<span class="byob-price-old"><span class="inr-sign"></span> ₹ ${formattedComparePrice.toLocaleString('en-IN')}</span>`;
      const discount = Math.round(((compareValue - priceValue) * 100) / compareValue);
      
      pricesDiv.innerHTML = priceHTML;
      
      let badge = priceRow.querySelector('.byob-discount-badge');
      if (badge) {
        badge.textContent = `${discount}% OFF`;
      } else {
        priceRow.insertAdjacentHTML('beforeend', `<span class="byob-discount-badge">${discount}% OFF</span>`);
      }
    } else {
      pricesDiv.innerHTML = priceHTML;
      const badge = priceRow.querySelector('.byob-discount-badge');
      if (badge) badge.remove();
    }
  }

  /**
   * Handle product selection - Open Quick View instead of adding directly
   */
  function handleProductSelection() {
    const card = this.closest('.byob-product-card');
    openQuickView(card);
  }

  /**
   * Navigate to a specific step
   */
  function goToStep(step, shouldScroll = false) {
    currentStep = step;

    // Update bottom box step navigation
    stepNavigations.forEach(nav => {
      const navStep = parseInt(nav.dataset.boxStep);
      if (navStep < step) {
        nav.classList.add('completed');
        nav.classList.remove('active');
      } else if (navStep === step) {
        nav.classList.add('active');
        nav.classList.remove('completed');
      } else {
        nav.classList.remove('active', 'completed');
      }
    });

    // Update step content visibility - ONLY show current step within active tab
    const activeTabContent = document.querySelector('.byob-tab-content[data-tab-content="' + currentTab + '"]');
    if (activeTabContent) {
      const tabStepContents = activeTabContent.querySelectorAll('.byob-step-content');
      tabStepContents.forEach(content => {
        const contentStep = parseInt(content.dataset.stepContent);
        if (contentStep === step) {
          content.style.display = 'block';
        } else {
          content.style.display = 'none';
        }
      });
    }

    // Only scroll if explicitly requested
    if (shouldScroll && step <= 3) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    updateUI();
  }

  /**
   * Update UI based on current state
   */
  function updateUI() {
    const step1Selected = selectedProducts.step1 !== null;
    const step2Selected = selectedProducts.step2 !== null;
    const step3Selected = selectedProducts.step3 !== null;
    
    const selectedCount = (step1Selected ? 1 : 0) + (step2Selected ? 1 : 0) + (step3Selected ? 1 : 0);
    const remaining = maxItems - selectedCount;

    // Update product count in header with proper grammar
    const boxCountElement = document.querySelector('.byob-box-count');
    const boxProductText = document.querySelector('.byob-product-text');
    if (boxCountElement) {
      boxCountElement.textContent = selectedCount;
    }
    if (boxProductText) {
      boxProductText.textContent = selectedCount === 1 ? 'Product' : 'Products';
    }

    // Update message
    if (selectedCount === 0) {
      boxMessage.textContent = `Select ${maxItems} products`;
    } else if (remaining > 0) {
      boxMessage.textContent = `Add ${remaining} more product${remaining > 1 ? 's' : ''}`;
    } else {
      boxMessage.textContent = 'Bundle Complete! Click "Add to Cart" below';
    }

    // Show/hide entire box-main section based on selection
    const boxMain = document.querySelector('.byob-box-main');
    const slotsContainer = document.querySelector('.byob-box-slots');
    const actionSection = document.querySelector('.byob-box-action');
    
    if (boxMain) {
      if (step1Selected || step2Selected) {
        boxMain.style.display = 'flex';
        // Also override CSS display rules for child elements
        if (slotsContainer) slotsContainer.style.display = 'flex';
        if (actionSection) actionSection.style.display = 'flex';
      } else {
        boxMain.style.display = 'none';
        if (slotsContainer) slotsContainer.style.display = 'none';
        if (actionSection) actionSection.style.display = 'none';
      }
    }

    // Update slots
    slots.forEach((slot, index) => {
      const slotStep = index + 1;
      const product = selectedProducts[`step${slotStep}`];
      const slotContent = slot.querySelector('.byob-slot-content');

      if (product) {
        slot.classList.remove('empty');
        slot.classList.add('filled');
        
        slotContent.innerHTML = `
          <img src="${product.image}" alt="${product.title}" class="byob-slot-image">
          <button class="byob-slot-remove" data-step="${slotStep}">×</button>
        `;

        // Add remove handler
        const removeBtn = slotContent.querySelector('.byob-slot-remove');
        removeBtn.addEventListener('click', function() {
          removeProduct(parseInt(this.dataset.step));
        });
      } else {
        slot.classList.remove('filled');
        slot.classList.add('empty');
        slotContent.innerHTML = `<span class="byob-slot-label">Step ${slotStep}</span>`;
      }
    });

    // Update pricing
    updatePricing();

    // Update checkout button - enable when all slots are filled
    const bundleComplete = selectedCount === maxItems;
    checkoutBtn.disabled = !bundleComplete;

    // Show/hide reset button
    if (resetBtn) {
      resetBtn.style.display = selectedCount > 0 ? 'inline-block' : 'none';
    }

    // Update all select buttons
    updateAllSelectButtons();
  }

  /**
   * Update all select buttons based on selection state
   */
  function updateAllSelectButtons() {
    document.querySelectorAll('.byob-add-btn').forEach(btn => {
      const btnStep = parseInt(btn.dataset.step);
      const product = selectedProducts[`step${btnStep}`];
      
      if (product && product.variantId === btn.dataset.variantId) {
        btn.textContent = 'ADDED ✓';
        btn.classList.add('added');
      } else {
        btn.textContent = 'ADD TO CART';
        btn.classList.remove('added');
      }
    });
  }

  /**
   * Remove product from selection
   */
  function removeProduct(step) {
    selectedProducts[`step${step}`] = null;
    goToStep(step);
  }

  /**
   * Calculate and update pricing with savings display
   */
  function updatePricing() {
    let totalPrice = 0;
    let engravingCharges = 0;

    if (selectedProducts.step1) {
      totalPrice += selectedProducts.step1.price;
      if (ENGRAVING_ENABLED && selectedProducts.step1.engraveName && selectedProducts.step1.engraveName.trim()) {
        engravingCharges += 4950; // ₹49.5 in paise
      }
    }
    if (selectedProducts.step2) {
      totalPrice += selectedProducts.step2.price;
      if (ENGRAVING_ENABLED && selectedProducts.step2.engraveName && selectedProducts.step2.engraveName.trim()) {
        engravingCharges += 4950; // ₹49.5 in paise
      }
    }
    if (selectedProducts.step3) {
      totalPrice += selectedProducts.step3.price;
      if (ENGRAVING_ENABLED && selectedProducts.step3.engraveName && selectedProducts.step3.engraveName.trim()) {
        engravingCharges += 4950; // ₹49.5 in paise
      }
    }
    
    // Add engraving charges to total only if engraving is enabled
    if (ENGRAVING_ENABLED) {
      totalPrice += engravingCharges;
    }

    // Count selected products
    const count = (selectedProducts.step1 ? 1 : 0) + (selectedProducts.step2 ? 1 : 0) + (selectedProducts.step3 ? 1 : 0);
    
    // Find applicable discount rule based on current maxItems (from active tab)
    const applicableRule = discountRules
      .filter(rule => rule.items === maxItems && count >= rule.items)
      .sort((a, b) => b.items - a.items)[0];

    let finalPrice = totalPrice;
    let originalPrice = totalPrice / 100; // Convert paise to rupees

    console.log('BYOB Pricing Debug:', {
      count,
      maxItems,
      totalPrice,
      originalPrice,
      applicableRule,
      currentBundlePrice,
      discountType,
      finalPrice
    });

    if (applicableRule && discountType === 'fixed_price') {
      // Use the current bundle price from active tab
      finalPrice = currentBundlePrice;
      
      console.log('Bundle pricing:', {
        finalPrice,
        originalPrice,
        hasSavings: originalPrice > finalPrice
      });
      
      // Show savings if bundle is complete (all required products selected)
      if (count === maxItems && originalPrice > finalPrice) {
        const savings = originalPrice - finalPrice;
        
        console.log('Showing savings:', savings);
        
        // Show original price with strikethrough
        if (boxOriginalPrice) {
          boxOriginalPrice.textContent = `₹${Math.round(originalPrice).toLocaleString('en-IN')}`;
          boxOriginalPrice.style.display = 'inline';
          boxOriginalPrice.style.visibility = 'visible';
          console.log('Original price element updated:', boxOriginalPrice.textContent, boxOriginalPrice.style.display);
        } else {
          console.log('boxOriginalPrice element not found!');
        }
        
        // Show savings badge with animation
        if (savingsBadge && savingsText) {
          savingsText.textContent = `Save ₹${Math.round(savings).toLocaleString('en-IN')}`;
          savingsBadge.style.display = 'flex';
          savingsBadge.style.visibility = 'visible';
          console.log('Savings badge updated:', savingsText.textContent, savingsBadge.style.display);
          
          // Add pulse animation
          savingsBadge.classList.remove('pulse-animation');
          void savingsBadge.offsetWidth; // Trigger reflow
          savingsBadge.classList.add('pulse-animation');
        } else {
          console.log('savingsBadge or savingsText element not found!', {
            savingsBadge,
            savingsText
          });
        }
      } else {
        console.log('Not showing savings - conditions not met');
        // Hide savings display if not applicable
        if (boxOriginalPrice) {
          boxOriginalPrice.style.display = 'none';
        }
        if (savingsBadge) {
          savingsBadge.style.display = 'none';
        }
      }
    } else {
      // Individual product prices are in paise, so divide by 100
      finalPrice = finalPrice / 100;
      
      // Hide savings display
      if (boxOriginalPrice) {
        boxOriginalPrice.style.display = 'none';
      }
      if (savingsBadge) {
        savingsBadge.style.display = 'none';
      }
    }

    // Format price: round and add comma formatting
    const formattedPrice = Math.round(finalPrice);
    boxTotal.textContent = `₹${formattedPrice.toLocaleString('en-IN')}`;
  }

  /**
   * Handle checkout - Add products to cart and redirect to checkout
   */
  async function handleCheckout() {
    // Check if bundle is complete
    const selectedCount = (selectedProducts.step1 ? 1 : 0) + (selectedProducts.step2 ? 1 : 0) + (selectedProducts.step3 ? 1 : 0);
    if (selectedCount !== maxItems) return;
    
    // Disable button and show loading state
    checkoutBtn.disabled = true;
    const originalText = checkoutBtn.textContent;
    checkoutBtn.textContent = 'Processing...';

    try {
      // Collect all selected products
      const items = [];
      if (selectedProducts.step1) items.push(selectedProducts.step1);
      if (selectedProducts.step2) items.push(selectedProducts.step2);
      if (selectedProducts.step3) items.push(selectedProducts.step3);
      
      console.log('BYOB: Adding products to cart:', {
        maxItems,
        selectedCount,
        items: items.map(i => ({ step: i.step, title: i.title, variantId: i.variantId }))
      });
      
      for (const item of items) {
        const properties = {
          '_byob': 'true',
          '_byob_step': `step${item.step}`
        };
        
        // Add engrave name if provided and add ₹99 charge as a property (only if enabled)
        if (item.engraveName && item.engraveName.trim()) {
          properties['Engrave Name'] = item.engraveName.trim();
          if (ENGRAVING_ENABLED) {
            properties['_Engraving Charge'] = '₹99';
          }
        }
        
        // Add the main product
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.variantId,
            quantity: 1,
            properties: properties
          })
        });
        
        // If engraving is enabled and selected, add the engraving product as a separate line item
        if (ENGRAVING_ENABLED && item.engraveName && item.engraveName.trim()) {
          console.log('Adding engraving product:', {
            variantId: ENGRAVING_VARIANT_ID,
            productTitle: item.title,
            engraveName: item.engraveName.trim()
          });
          
          const engraveResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: ENGRAVING_VARIANT_ID,
              quantity: 1,
              properties: {
                '_for_product': item.title,
                '_engraved_name': item.engraveName.trim(),
                '_byob_engraving': 'true'
              }
            })
          });
          
          const engraveData = await engraveResponse.json();
          console.log('Engraving product response:', engraveData);
          
          if (!engraveResponse.ok) {
            console.error('Failed to add engraving product:', engraveData);
            throw new Error('Failed to add engraving: ' + (engraveData.description || engraveData.message));
          }
        }
      }

      // Show success message
      checkoutBtn.textContent = 'Added to Cart ✓';
      checkoutBtn.style.background = '#27AE60';
      
      // Trigger cart count update
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Reset after delay - NO REDIRECT
      setTimeout(() => {
        selectedProducts.step1 = null;
        selectedProducts.step2 = null;
        selectedProducts.step3 = null;
        goToStep(1);
        checkoutBtn.textContent = originalText;
        checkoutBtn.style.background = '';
        checkoutBtn.disabled = false;
      }, 1500);

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error: ' + error.message + '\n\nCheck console (F12) for details.');
      checkoutBtn.disabled = false;
      checkoutBtn.textContent = originalText;
      checkoutBtn.style.background = '';
    }
  }

  /**
   * Add products to cart with engrave name from individual products
   */
  async function addToCartWithEngrave(engraveName) {
    const engraveConfirmBtn = document.getElementById('engrave-confirm-btn');
    const engraveSkipBtn = document.getElementById('engrave-skip-btn');
    const originalText = engraveConfirmBtn.textContent;
    
    engraveConfirmBtn.disabled = true;
    engraveSkipBtn.disabled = true;
    engraveConfirmBtn.textContent = 'Adding to Cart...';

    try {
      // Add both products to cart
      const items = [selectedProducts.step1, selectedProducts.step2];
      
      for (const item of items) {
        const properties = {
          '_byob': 'true',
          '_byob_step': `step${item.step}`
        };
        
        // Calculate price with engraving charge
        let itemPrice = item.price; // Price in paise
        
        // Use engrave name from individual product if available, otherwise use the one from popup
        const finalEngraveName = item.engraveName || engraveName;
        if (finalEngraveName && finalEngraveName.trim()) {
          properties['Engrave Name'] = finalEngraveName.trim();
          itemPrice += 9900; // Add ₹99 (9900 paise) for engraving
        }
        
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.variantId,
            quantity: 1,
            price: itemPrice,
            properties: properties
          })
        });
      }

      // Show success
      engraveConfirmBtn.textContent = 'Added to Cart ✓';
      engraveConfirmBtn.style.background = '#27AE60';

      // Trigger cart count update if using AJAX cart
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Close popup and reset after delay
      setTimeout(() => {
        closeEngravePopup();
        selectedProducts.step1 = null;
        selectedProducts.step2 = null;
        goToStep(1);
        engraveConfirmBtn.textContent = originalText;
        engraveConfirmBtn.style.background = '';
        engraveConfirmBtn.disabled = false;
        engraveSkipBtn.disabled = false;
      }, 1500);

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Sorry, there was an error. Please try again.');
      engraveConfirmBtn.disabled = false;
      engraveSkipBtn.disabled = false;
      engraveConfirmBtn.textContent = originalText;
      engraveConfirmBtn.style.background = '';
    }
  }

  /**
   * Quick View Modal
   */
  const modal = document.getElementById('byob-quick-view');
  const modalOverlay = modal ? modal.querySelector('.byob-modal-overlay') : null;
  const modalClose = modal ? modal.querySelector('.byob-modal-close') : null;
  const modalAddBtn = document.getElementById('modal-add-to-cart');

  // Image carousel state
  let currentImageIndex = 0;
  let currentGalleryImages = [];

  /**
   * Load image gallery into carousel
   */
  function loadImageGallery(images) {
    const track = document.getElementById('modal-image-track');
    const prevBtn = document.querySelector('.byob-modal-image-prev');
    const nextBtn = document.querySelector('.byob-modal-image-next');
    
    if (!track) return;
    
    currentImageIndex = 0;
    track.innerHTML = '';
    
    images.forEach((imgSrc, index) => {
      const slide = document.createElement('div');
      slide.className = 'byob-modal-image-slide';
      slide.innerHTML = `<img src="${imgSrc}" alt="Product image ${index + 1}">`;
      track.appendChild(slide);
    });
    
    // Show/hide navigation buttons
    if (images.length > 1) {
      if (prevBtn) prevBtn.style.display = 'flex';
      if (nextBtn) nextBtn.style.display = 'flex';
    } else {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }
    
    updateCarouselPosition();
  }

  /**
   * Update carousel position
   */
  function updateCarouselPosition() {
    const track = document.getElementById('modal-image-track');
    if (!track) return;
    
    const slideWidth = 100; // percentage
    track.style.transform = `translateX(-${currentImageIndex * slideWidth}%)`;
  }

  /**
   * Navigate carousel
   */
  function navigateCarousel(direction) {
    if (direction === 'next' && currentImageIndex < currentGalleryImages.length - 1) {
      currentImageIndex++;
    } else if (direction === 'prev' && currentImageIndex > 0) {
      currentImageIndex--;
    }
    updateCarouselPosition();
  }

  // Carousel navigation event listeners
  const prevBtn = document.querySelector('.byob-modal-image-prev');
  const nextBtn = document.querySelector('.byob-modal-image-next');
  
  if (prevBtn) {
    prevBtn.addEventListener('click', () => navigateCarousel('prev'));
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', () => navigateCarousel('next'));
  }

  // Touch/swipe support for mobile
  let touchStartX = 0;
  let touchEndX = 0;
  
  const carousel = document.querySelector('.byob-modal-image-carousel');
  if (carousel) {
    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });
    
    carousel.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });
  }
  
  function handleSwipe() {
    const swipeThreshold = 50;
    if (touchStartX - touchEndX > swipeThreshold) {
      navigateCarousel('next');
    } else if (touchEndX - touchStartX > swipeThreshold) {
      navigateCarousel('prev');
    }
  }

  function openQuickView(productCard) {
    if (!modal) return;

    const productId = productCard.dataset.productId;
    const step = productCard.dataset.step;
    const mainImage = productCard.querySelector('.byob-main-image');
    const title = productCard.querySelector('.byob-product-title').textContent;
    const priceRow = productCard.querySelector('.byob-product-price-row');
    const variantName = productCard.querySelector('.byob-variant-name');
    const swatches = productCard.querySelectorAll('.byob-swatch');
    const addBtn = productCard.querySelector('.byob-add-btn');

    // Get active swatch to load its gallery
    const activeSwatch = productCard.querySelector('.byob-swatch.active');
    if (activeSwatch && activeSwatch.dataset.gallery) {
      currentGalleryImages = activeSwatch.dataset.gallery.split('|').filter(img => img);
      console.log('Gallery images found:', currentGalleryImages);
      loadImageGallery(currentGalleryImages);
    } else {
      console.log('No gallery found, using main image');
      currentGalleryImages = [mainImage.src];
      loadImageGallery(currentGalleryImages);
    }

    // Populate modal
    document.getElementById('modal-product-title').textContent = title;
    
    // Get description from button data attribute
    const description = addBtn.dataset.description || 'Select your preferred variant and add to your bundle.';
    document.getElementById('modal-product-desc').innerHTML = description;
    document.getElementById('modal-product-prices').innerHTML = 
      priceRow.querySelector('.byob-prices').innerHTML;
    
    const discountBadge = priceRow.querySelector('.byob-discount-badge');
    document.getElementById('modal-product-badge').innerHTML = 
      discountBadge ? discountBadge.outerHTML : '';
    
    document.getElementById('modal-variant-name').textContent = variantName.textContent;

    // Copy rating from product card to modal
    const ratingBadge = productCard.querySelector('.byob-rating-badge');
    const modalRating = document.querySelector('.byob-modal-rating');
    if (modalRating) {
      if (ratingBadge) {
        modalRating.innerHTML = ratingBadge.innerHTML;
        modalRating.style.display = 'flex';
      } else {
        modalRating.innerHTML = '';
        modalRating.style.display = 'none';
      }
    }

    // Reset engrave input and setup character counter
    const modalEngraveInput = document.getElementById('modal-engrave-input');
    const modalEngraveSection = document.querySelector('.byob-modal-engrave-section');
    const modalCharCount = document.querySelector('.byob-modal-char-count');
    const modalEngraveLabel = document.querySelector('.byob-modal-engrave-label');
    
    // Always show engraving section, but update the label based on setting
    if (modalEngraveLabel) {
      const chargeSpan = modalEngraveLabel.querySelector('span[style*="color"]');
      if (chargeSpan) {
        chargeSpan.style.display = ENGRAVING_ENABLED ? 'inline' : 'none';
      }
    }
    
    // Update placeholder based on setting
    if (modalEngraveInput) {
      modalEngraveInput.value = '';
      modalEngraveInput.placeholder = 'Enter your name';
      if (modalCharCount) {
        modalCharCount.textContent = '0/12 characters';
      }
      // Add input event listener for character counter
      modalEngraveInput.removeEventListener('input', updateModalCharCount);
      modalEngraveInput.addEventListener('input', updateModalCharCount);
    }

    // Clone swatches
    const modalSwatches = document.getElementById('modal-variant-swatches');
    modalSwatches.innerHTML = '';
    
    swatches.forEach(swatch => {
      const clonedSwatch = swatch.cloneNode(true);
      clonedSwatch.addEventListener('click', function() {
        if (this.dataset.disabled) return;

        modalSwatches.querySelectorAll('.byob-swatch').forEach(s => s.classList.remove('active'));
        this.classList.add('active');

        // Load gallery for selected variant
        if (this.dataset.gallery) {
          currentGalleryImages = this.dataset.gallery.split('|').filter(img => img);
          loadImageGallery(currentGalleryImages);
        }

        document.getElementById('modal-variant-name').textContent = this.dataset.title;

        const price = parseFloat(this.dataset.price);
        const comparePrice = this.dataset.compare ? parseFloat(this.dataset.compare) : 0;

        const formattedPrice = Math.round(price / 100);
        let priceHTML = `<span class="byob-price-current"><span class="inr-sign"></span> ₹ ${formattedPrice.toLocaleString('en-IN')}</span>`;
        if (comparePrice > price) {
          const formattedComparePrice = Math.round(comparePrice / 100);
          priceHTML += `<span class="byob-price-old"><span class="inr-sign"></span> ₹ ${formattedComparePrice.toLocaleString('en-IN')}</span>`;
          const discount = Math.round(((comparePrice - price) * 100) / comparePrice);
          document.getElementById('modal-product-badge').innerHTML = 
            `<span class="byob-discount-badge">${discount}% OFF</span>`;
        } else {
          document.getElementById('modal-product-badge').innerHTML = '';
        }
        document.getElementById('modal-product-prices').innerHTML = priceHTML;

        modalAddBtn.dataset.variantId = this.dataset.variantId;
        modalAddBtn.dataset.price = this.dataset.price;
        modalAddBtn.dataset.image = this.dataset.thumb;
      });
      modalSwatches.appendChild(clonedSwatch);
    });

    // Update modal add button
    modalAddBtn.dataset.productId = productId;
    modalAddBtn.dataset.variantId = addBtn.dataset.variantId;
    modalAddBtn.dataset.price = addBtn.dataset.price;
    modalAddBtn.dataset.title = title;
    modalAddBtn.dataset.image = addBtn.dataset.image;
    modalAddBtn.dataset.step = step;

    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeQuickView() {
    if (!modal) return;
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (modalClose) {
    modalClose.addEventListener('click', closeQuickView);
  }
  if (modalOverlay) {
    modalOverlay.addEventListener('click', closeQuickView);
  }

  if (modalAddBtn) {
    modalAddBtn.addEventListener('click', function() {
      const step = parseInt(this.dataset.step);
      const productId = this.dataset.productId;
      const variantId = this.dataset.variantId;
      const price = parseFloat(this.dataset.price);
      const title = this.dataset.title;
      const image = this.dataset.image;

      // Get engrave name from modal input
      const modalEngraveInput = document.getElementById('modal-engrave-input');
      const engraveName = modalEngraveInput ? modalEngraveInput.value.trim() : '';

      // In single collection mode, find next available slot
      let targetStep = step;
      if (bundleMode === 'single') {
        if (!selectedProducts.step1) {
          targetStep = 1;
        } else if (!selectedProducts.step2) {
          targetStep = 2;
        } else if (!selectedProducts.step3 && maxItems >= 3) {
          targetStep = 3;
        } else {
          // All slots full, replace the clicked step
          targetStep = step;
        }
      }

      // Store in state for UI (don't add to cart yet)
      selectedProducts[`step${targetStep}`] = {
        productId,
        variantId,
        price,
        title,
        image,
        step: targetStep,
        engraveName: engraveName // Store engrave name with product
      };

      updateUI();
      closeQuickView();

      // Auto-reveal box when product is added
      reopenBox();

      // AUTO-NAVIGATE: In step mode, move to next step after selection
      if (bundleMode === 'step') {
        if (targetStep === 1 && maxItems >= 2) {
          setTimeout(() => {
            goToStep(2);
          }, 500);
        } else if (targetStep === 2 && maxItems >= 3) {
          setTimeout(() => {
            goToStep(3);
          }, 500);
        }
      }
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal && modal.classList.contains('active')) {
      closeQuickView();
    }
  });

  /**
   * Engrave Popup Modal
   */
  const engravePopup = document.getElementById('byob-engrave-popup');
  const engraveInput = document.getElementById('engrave-name-input');
  const engraveCharCount = document.querySelector('.byob-engrave-char-count');
  const engraveConfirmBtn = document.getElementById('engrave-confirm-btn');
  const engraveSkipBtn = document.getElementById('engrave-skip-btn');
  const engraveTotalPrice = document.getElementById('engrave-total-price');

  function openEngravePopup() {
    if (!engravePopup) return;

    // Populate product images and names
    if (selectedProducts.step1) {
      document.getElementById('engrave-product-1-img').src = selectedProducts.step1.image;
      document.getElementById('engrave-product-1-name').textContent = selectedProducts.step1.title;
    }
    if (selectedProducts.step2) {
      document.getElementById('engrave-product-2-img').src = selectedProducts.step2.image;
      document.getElementById('engrave-product-2-name').textContent = selectedProducts.step2.title;
    }

    // Update total price
    const count = (selectedProducts.step1 ? 1 : 0) + (selectedProducts.step2 ? 1 : 0);
    const applicableRule = discountRules
      .filter(rule => count >= rule.items)
      .sort((a, b) => b.items - a.items)[0];

    let finalPrice = 0;
    if (selectedProducts.step1) finalPrice += selectedProducts.step1.price;
    if (selectedProducts.step2) finalPrice += selectedProducts.step2.price;

    if (applicableRule && discountType === 'fixed_price') {
      finalPrice = parseFloat(applicableRule.value);
    }

    engraveTotalPrice.textContent = `₹${Math.round(finalPrice)}`;

    // Reset input
    if (engraveInput) {
      engraveInput.value = '';
      updateCharCount();
    }

    // Show popup
    engravePopup.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeEngravePopup() {
    if (!engravePopup) return;
    engravePopup.classList.remove('active');
    document.body.style.overflow = '';
  }

  function updateCharCount() {
    if (engraveInput && engraveCharCount) {
      const length = engraveInput.value.length;
      engraveCharCount.textContent = `${length}/30 characters`;
    }
  }

  function updateModalCharCount() {
    const modalEngraveInput = document.getElementById('modal-engrave-input');
    const modalCharCount = document.querySelector('.byob-modal-char-count');
    if (modalEngraveInput && modalCharCount) {
      const length = modalEngraveInput.value.length;
      modalCharCount.textContent = `${length}/12 characters`;
    }
  }

  // Engrave popup event listeners
  if (engravePopup) {
    const engraveOverlay = engravePopup.querySelector('.byob-modal-overlay');
    const engraveCloseBtn = engravePopup.querySelector('.byob-modal-close');

    if (engraveCloseBtn) {
      engraveCloseBtn.addEventListener('click', closeEngravePopup);
    }

    if (engraveOverlay) {
      engraveOverlay.addEventListener('click', closeEngravePopup);
    }

    if (engraveInput) {
      engraveInput.addEventListener('input', updateCharCount);
    }

    if (engraveConfirmBtn) {
      engraveConfirmBtn.addEventListener('click', function() {
        const engraveName = engraveInput ? engraveInput.value : '';
        addToCartWithEngrave(engraveName);
      });
    }

    if (engraveSkipBtn) {
      engraveSkipBtn.addEventListener('click', function() {
        addToCartWithEngrave('');
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && engravePopup.classList.contains('active')) {
        closeEngravePopup();
      }
    });
  }

  // Initialize the app
  init();

})();
